import React from 'react';

import ChatMiawGate from 'components/ChatMiawGate';
import MethodicChatGate from './MethodicChatGate';
import useMethodicSession from './useMethodicSession';

export interface ChatGateProps {
	children: React.ReactNode;
}

/**
 * Chooses which support chat widget the app mounts. An environment with a
 * Methodic channel key configured (`appConfig.methodic.apiKey`) gets the
 * Methodic AI chat instead of the Salesforce MIAW chat — the two never run
 * together, so an environment without a Methodic key is unaffected.
 */
const ChatGate = ({ children }: ChatGateProps) => {
	const { isEnabled } = useMethodicSession();
	const Gate = isEnabled ? MethodicChatGate : ChatMiawGate;

	return <Gate>{children}</Gate>;
};

export default ChatGate;
